"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _withTheme = _interopRequireDefault(require("./withTheme"));
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
var _default = exports.default = (0, _withTheme.default)(() => /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
  d: "M18.49,17.26,14,12.78A7.87,7.87,0,1,0,12.78,14l4.48,4.47a.86.86,0,0,0,1.23,0A.86.86,0,0,0,18.49,17.26ZM1.75,7.87A6.12,6.12,0,1,1,7.87,14,6.13,6.13,0,0,1,1.75,7.87Z"
}), '0 0 18.75 18.75');